
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');


const RoutemapAction = (props) => {
    
    const handleClick = (e) => {
        e.stopPropagation();
        //console.log("Props Routmap ", props);
        props.agGridReact.props.gridOptions.context.componentParent.onShowTicketHistory(props);
    };

    return (
        <div>
			<button title="Ticket History" onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-history f20"></i> </button>
       
        </div>
    );
};

export default RoutemapAction;
